import { connect, ConnectedProps } from 'react-redux';

import GetStartedSurveyPage from '../pages/GetStartedSurveyPage';

import {
  IPropyCookieValue,
} from '../interfaces';

interface RootState {
  propyCookieValue: string;
}
  
const mapStateToProps = (state: RootState) => ({
  propyCookieValue: JSON.parse(state.propyCookieValue) as IPropyCookieValue,
})
  
const connector = connect(mapStateToProps, {})
  
export type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(GetStartedSurveyPage)